import { Controller } from '@hotwired/stimulus'

export default class extends Controller {

  open(e) {
    const element = e.currentTarget.parentNode;
    if (element.classList.contains('faq-list__item_active')) {
      element.classList.remove('faq-list__item_active')
    } else {
      element.classList.add('faq-list__item_active')
    }
  }

}